import { Building, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { TOWNS } from "@/components/site/areaContent";

export const ServiceIndustries = ({ content }) => (
  <section data-testid="service-industries-section" className="bg-brand-surface/50 py-16 lg:py-20">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
      <div className="max-w-sm">
        <p className="eyebrow">Industries</p>
        <h2 className="mt-4 font-heading text-2xl font-semibold tracking-tight text-brand-navy">Industries We Serve</h2>
      </div>
      <ul className="flex flex-wrap gap-2.5 lg:max-w-2xl lg:justify-end">
        {content.industries.map((name, i) => (
          <li key={name} data-testid={`service-industry-chip-${i}`} className="inline-flex items-center gap-2 rounded-full border border-brand-blue/20 bg-white px-4 py-2 font-body text-sm font-medium text-brand-navy">
            <Building className="h-3.5 w-3.5 text-brand-blue" strokeWidth={1.8} /> {name}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export const ServiceFaq = ({ content }) => (
  <section data-testid="service-faq-section" className="bg-white py-20 lg:py-24">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <div>
        <p className="eyebrow">FAQ</p>
        <h2 className="h2 mt-5">{content.short} Questions, Answered</h2>
        <p className="lead mt-4 max-w-sm">Don't see your question here? Give us a call. We're happy to help.</p>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {content.faqs.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-brand-surface" data-testid={`service-faq-item-${i}`}>
            <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-brand-navy hover:text-brand-blue hover:no-underline" data-testid={`service-faq-trigger-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-brand-slate">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export const AreaLine = () => (
  <section data-testid="service-area-line" className="border-y border-brand-surface bg-white">
    <div className="mx-auto flex max-w-7xl items-start gap-3 px-5 py-7 sm:items-center sm:px-8">
      <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-blue sm:mt-0" strokeWidth={1.75} />
      <p className="font-heading text-sm font-semibold text-brand-navy sm:text-base">
        Proudly serving <Link to="/areas" className="underline decoration-brand-surface underline-offset-4 hover:text-brand-blue" data-testid="area-line-link-hub">Chatham-Kent</Link>,{" "}
        {TOWNS.map((t, i) => (
          <span key={t.slug}>
            <Link to={`/areas/${t.slug}`} className="underline decoration-brand-surface underline-offset-4 hover:text-brand-blue" data-testid={`area-line-link-${t.slug}`}>{t.name}</Link>
            {i < TOWNS.length - 2 ? ", " : i === TOWNS.length - 2 ? " and " : ""}
          </span>
        ))}{" "}
        and surrounding areas.
      </p>
    </div>
  </section>
);
